




import Vue from 'vue'
export default Vue.extend({
  props: {
    status: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    eventLabelClass() {
      let type = this.status && this.status.type
      return ['Label', 'Label-' + type]
    },
  },
})
